import { useState } from "react";
import { Fade } from "react-awesome-reveal";
// import GoBackBtn from "utils/goBackBtn";
import { EyeIcon, WebLogo } from "utils/Icons";
// import { Link } from "react-router-dom";
import { auth } from "config/firebase";
import { useSelector } from "react-redux";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import Spinner from "utils/Spinner";
import QueryChecker from "utils/queryChecker";

// login page
const Login = () => {
  const { isAuthenticated, isLoading } = useSelector((store) => store.auth);
  let location = useLocation();

  const withQuery = QueryChecker(["promo","email","sId"]);

  const [searchParams] = useSearchParams();
  const paramsEmail = searchParams.get("email");
  const { from } = location.state || {
    from: { pathname: "/myAccount" + withQuery },
  };

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  // hide/show password
  const [showPass, setShowPass] = useState(false);
  // loading
  const [isSubmitting, setIsSubmitting] = useState(false);

  // handle form input
  const handleForm = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // signIn
  const handleSignedIn = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    auth
      .signInWithEmailAndPassword(
        paramsEmail || formData.email,
        formData.password
      )
      .then(() => {
        // console.log(userCredential.user);
      })
      .catch((error) => {
        console.log(error);
        alert(error.message);
        setIsSubmitting(false);
      });
  };

  if (isLoading)
    return (
      <div className="cs_container h_100 d_flex flex_col align_items_center justify_content_center text_center text_white">
        <Spinner />
      </div>
    );
  if (isAuthenticated) return <Navigate to={from?.pathname} replace />;
  return (
    <div className="text_white text_center signup_card">
      <br />
      <form onSubmit={handleSignedIn} className="signup_card_inner ">
        <div className="step_card_body justify_content_start">
          <Fade triggerOnce delay={200} duration={1000}>
            <WebLogo className="mx_auto" />
          </Fade>
          <br />
          <div className="input_wrapper">
            {paramsEmail ? (
              <input
                name="email"
                type="email"
                readOnly
                formNoValidate
                required
                valid="true"
                defaultValue={paramsEmail}
                style={{ cursor: "not-allowed" }}
              />
            ) : (
              <input
                name="email"
                type="email"
                required
                onChange={handleForm}
                value={formData?.email}
              />
            )}
            <div
              className={`input_underline ${
                paramsEmail ? "active" : formData.email ? "active" : ""
              }`}
            ></div>
            <label
              className={` ${
                paramsEmail ? "active" : formData.email ? "active" : ""
              }`}
            >
              Email
            </label>
          </div>
          <div className="input_wrapper">
            <input
              name="password"
              type={showPass ? "text" : "Password"}
              required
              onChange={handleForm}
              value={formData?.password}
            />
            <div
              role="button"
              onClick={() => setShowPass((state) => !state)}
              className="input_show_pass_icon"
            >
              <EyeIcon className={showPass ? "showpass" : ""} />
            </div>
            <div className="input_underline"></div>
            <label>Password</label>
          </div>
        </div>
        <br />
        <div className="mt_auto screen_sticky_footer">
          <Fade triggerOnce delay={1400} duration={1300}>
            <button
              type="submit"
              disabled={isSubmitting}
              className="cs_btn w_100"
            >
              {isSubmitting ? " Submitting... " : " Login to your account"}
            </button>
          </Fade>
        </div>
      </form>
    </div>
  );
};

export default Login;
